import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { TranslateService } from "@ngx-translate/core";

@Directive({
  selector: '[appStatisticsPercent]',
  providers: [DecimalPipe]
})
export class StatisticsPercentDirective implements OnChanges {

  @Input('appStatisticsPercent') value: number;

  constructor(
    private el: ElementRef,
    private decimalPipe: DecimalPipe,
    public translate: TranslateService
  ) {}

  ngOnChanges() {

    if (this.value > 0) {
      this.el.nativeElement.style.color = '#00a026';
      this.el.nativeElement.innerText = `(${this.translate.instant('statistic.up_to')} ${this.decimalPipe.transform(this.value, '1.1-1')} %)`;
    }

    if (this.value < 0) {
      this.el.nativeElement.style.color = '#ffa831';
      this.el.nativeElement.innerText = `(${this.translate.instant('statistic.down_to')} ${this.decimalPipe.transform(this.value, '1.1-1')} %)`;
    }

  }

}
